import Job from "@/views/questions/job/index.vue";
import PersonType from "@/views/questions/person_type/index.vue";
import IncomeRate from "@/views/questions/income_rate/index.vue";
import Vat from "@/views/questions/vat/index.vue";
import VatNeeded from "@/views/questions/vat_needed/index.vue";
import GoodsType from "@/views/questions/goods_type/index.vue";
import Cheat from "@/views/questions/cheat/index.vue";
import FinalDecision from "@/views/questions/final_decision/index.vue";

export default [
  {
    path: "/questions/job",
    name: "Job",
    component: Job,
  },
  {
    path: "/questions/person_type",
    name: "PersonType",
    component: PersonType,
  },
  {
    path: "/questions/income_rate",
    name: "IncomeRate",
    component: IncomeRate,
  },
  {
    path: "/questions/vat",
    name: "Vat",
    component: Vat,
  },
  {
    path: "/questions/vat_needed",
    name: "VatNeeded",
    component: VatNeeded,
  },
  {
    path: "/questions/goods_type",
    name: "GoodsType",
    component: GoodsType,
  },
  {
    path: "/questions/cheat",
    name: "Cheat",
    component: Cheat,
  },
  {
    path: "/questions/final_decision",
    name: "FinalDecision",
    component: FinalDecision,
  },
];
